// A repeat of the student's latest pick (in flight, else selected). Repeats are
// dropped because every send adds its own line to the Transcript.
export const isRepeatMcAnswer = (index, selectedIndex, pendingIndex) =>
  index === (pendingIndex ?? selectedIndex);
